import * as React from "react";
import { TTranslate } from "../../../../service/locale/TranslationService";
import { TPublicationsReportApplicantPresentationModel } from "../../../../presenter/report/model/PublicationsReportApplicantPresentationModel";
import { Typography } from "antd";
import PublicationsReportApplicant from "./PublicationsReportApplicant";

const PublicationsReportPreview = ({
  translate,
  title,
  applicants,
  subtitle,
  loader
}: {
  translate: TTranslate;
  applicants: TPublicationsReportApplicantPresentationModel[];
  title?: string;
  subtitle?: string;
  loader?: boolean;
}) => {
  const renderApplicants = () => {
    let report6PreviewApplicants: JSX.Element[] = [];
    applicants.forEach(
      (applicant: TPublicationsReportApplicantPresentationModel) => {
        applicant.applicantId &&
          report6PreviewApplicants.push(
            <PublicationsReportApplicant
              key={`applicant-${applicant.applicantId}`}
              translate={translate}
              applicant={applicant}
            />
          );
      }
    );
    return report6PreviewApplicants;
  };

  return (
    <div>
      {title && (
        <Typography.Title style={{ fontSize: 25 }}>{title}</Typography.Title>
      )}
      {subtitle && (
        <Typography.Title style={{ fontSize: 20, marginBottom: 20 }}>
          {subtitle}
        </Typography.Title>
      )}
      {renderApplicants()}
    </div>
  );
};

export default PublicationsReportPreview;
